import axios from 'axios'

import Termly from 'termly-namespace'

import URL from 'utils/url'


export default function statisticViewApiCall(eventTypes) {
  const postURL = URL.statistic()

  return axios
    .post(postURL, {
      event_types: eventTypes,
      website_uuid: Termly.websiteUUID,
    })
    .catch(({ message }) => {
      console.error('Encountered %o when trying to post statistics to %s',
                    message,
                    postURL)
    })
}
